import React, { useState } from "react";
import CSS from 'csstype';
import style from '../style.module.scss';
import { IBarGraphProps } from "../types";
import { CssStylesForHint } from "../helper";
import { Hint, HorizontalGridLines, VerticalBarSeries, 
  VerticalBarSeriesPoint, VerticalGridLines, XAxis, 
  XAxisProps, XYPlot, YAxis, ChartLabel } from "react-vis";

const NS = 'BarGraph';

/**
 * Renders the bar graph with the provided series points.
 */
export const BarGraph = (props: IBarGraphProps) => {

  const [hoveredNode, setHoverNode] = useState<VerticalBarSeriesPoint | null>(null);

  if (!props.barSeriesPointsGroup) return null;

  // Iterate through each service and create a bar
  const barSeriesGroup = !!props.barSeriesPointsGroup ? Object.values(props.barSeriesPointsGroup).map((group: VerticalBarSeriesPoint[], index) => {
    return <VerticalBarSeries key={index} data={group} barWidth={0.8} colorType="literal"
    onValueMouseOver={d => setHoverNode({x: d.x, y: d.y, amount: d.amount, service: d.service, header: d.header})} />
  }) : null;

  return (
    <div className={style.bargraphContainer}>
      { !!props.title && <h2>{props.title}</h2> }
      {
        !!props.barSeriesPointsGroup &&
        <XYPlot margin={{left: 50, top: 30, bottom: 50}} xType="ordinal" width={500} height={400} onMouseLeave={() => setHoverNode(null)}>
          <VerticalGridLines style={GridLineColour} />
          <HorizontalGridLines style={GridLineColour} />
          {barSeriesGroup}
          <XAxis style={CssStylesForAxis.style} />
          <YAxis style={CssStylesForAxis.style} />
          {
            hoveredNode &&
            <Hint value={{ x: hoveredNode.x, y: hoveredNode.y }} style={CssStylesForHint}>
              <div>
                <p>{hoveredNode.header}</p>
                <p style={{margin: '5px'}}>{hoveredNode.service} : ${hoveredNode.amount}</p>
              </div>
            </Hint>
          }
          <ChartLabel 
            text="Booking size"
            className="alt-x-label"
            xPercent={1}
            yPercent={0.85}
            style={{
              textAnchor: 'end'
            }}
            />

          <ChartLabel 
            text="Total spend"
            className="alt-y-label"
            xPercent={-0.06}
            yPercent={0.05}
            style={{
              textAnchor: 'start'
            }}
            includeMargin={false}
          />
        </XYPlot>
      }
    </div>
  );
}

/** CSS styles */
const GridLineColour: React.CSSProperties = { stroke: "#B7E9ED" }
const AxisLineColour: React.CSSProperties = { stroke: "#ADDDE1" }

const CssStylesForAxis: XAxisProps = {
  style: {
    line: AxisLineColour,
    ticks: AxisLineColour,
    text: { stroke: "none", fill: "#6b6b76" }
  }
}